import Splitting from 'splitting'
import Resize from '@/mixins/Resize'

export default
{
    mixins: [
        Resize
    ],

    props:
    {
        isType: { type: String, default: 'div' }
    },

    data()
    {
        return {
            fixTransition: ['anim-enter']
        }
    },

    created()
    {
        this.fixTransition = ['anim-enter']
    },

    mounted()
    {
        this.parseText(true)
        this.startAnimation()
    },

    methods:
    {
        startAnimation()
        {
            requestAnimationFrame(() =>
            {
                requestAnimationFrame(() => this.fixTransition = [])
            })
        },

        onResized()
        {
            this.parseText()
        },

        parseText(first = false)
        {
            if (first)
            {
                this.originalText = this.$refs.in.innerHTML
                this.$refs.in.parentNode.removeChild(this.$refs.in)
            }
            else
            {
                this.$el.removeChild(this.$el.lastChild)
            }

            const span = document.createElement('SPAN')
            span.innerHTML = this.originalText
            this.$el.appendChild(span)

            const splitted = Splitting({
                target: span,
                by: 'lines'
            })

            let currLine = 0
            splitted.forEach(({ lines }) =>
            {
                lines.forEach(line =>
                {
                    currLine += 1
                    line.forEach(word =>
                    {
                        word.classList.add('line-' + currLine)
                    })
                })
                currLine += 1
            })
        }
    }
}
